import { render, staticRenderFns } from "./UsersTab.vue?vue&type=template&id=36344a2a&scoped=true&"
import script from "./UsersTab.vue?vue&type=script&lang=js&"
export * from "./UsersTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36344a2a",
  null
  
)

export default component.exports